import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import DeleteIcon from 'src/assets/images/DeleteIcon.svg';
import MDIedit from 'src/assets/images/MDIedit.svg';
import MDIEditDisable from 'src/assets/images/MDIEditDisable.svg';
import CloseBlue from 'src/assets/images/CloseBlue.svg';
import TickBlue from 'src/assets/images/TickBlue.svg';
import { convertTime24To12, logErrorToConsole } from 'src/utils/util';
import { getDisplayDate } from 'src/utils/dateUtils';
import EditCard from './EditCard';
import SuccessMsgContainer from './SuccessMsgContainer';
import {
    Subtitle,
    SubtitleDiv,
    SurgeryInput,
    ButtonDiv,
    StyledDiv,
    Line,
    DisplayDiv,
    SurgeryNoteCharactersCount,
    NoteDiv,
    Flex,
    Creator,
    Bar,
    StyledDate,
    Time,
    Del,
    Edit,
    NoteDetails,
} from './CustomerCareNotes.styled';
import {
    NotesContainer,
    MainContainerItems,
} from 'src/common/components/reviewAndSubmitNotes/reviewAndSubmitNotes.styled.jsx';

// Third "New Usage Adj Note" section for the Report Usage notes flow.
const UsageAdjNoteSection = ({
    header,
    subHeader,
    notesText,
    onChange,
    onSave,
    onCancel,
    onDelete,
    notesDisplay = [],
    charCountLimit = 4000,
    hideHeader = false,
    mobile = false,
    editIndex = null,
    editValue = null,
    onEdit = () => {},
    onEditChange = () => {},
    onEditClose = () => {},
    onEditSave = () => {},
    showSuccessMessage = false,
}) => {
    const { t } = useTranslation();
    const remaining =
        charCountLimit - (notesText?.length || 0) < 0
            ? 0
            : charCountLimit - (notesText?.length || 0);

    return (
        <div style={{ marginTop: mobile ? '0px' : '20px' }}>
            <DisplayDiv>
                {!mobile && (
                    <SubtitleDiv>
                        {!hideHeader && <Subtitle>{header}</Subtitle>}
                        <SurgeryNoteCharactersCount margin="0px 5px 0px 0px">
                            {`${remaining} ${t('equity.surgery.remainchar')}`}
                        </SurgeryNoteCharactersCount>
                    </SubtitleDiv>
                )}
                <SurgeryInput
                    placeholder={t('reportUsage.usageAdjNote.placeholder')}
                    value={notesText}
                    onChange={(e) => onChange(e, 'noteThree')}
                    maxLength={charCountLimit}
                ></SurgeryInput>
                {mobile && (
                    <SurgeryNoteCharactersCount margin="0px 5px 0px 0px">
                        {`${remaining} ${t('equity.surgery.remainchar')}`}
                    </SurgeryNoteCharactersCount>
                )}
                <ButtonDiv justifyContent={'flex-end'}>
                    <Button
                        id={'common-usage-adj-notes-clear-button'}
                        width={'102px'}
                        mobileWidth={'150px'}
                        height={'38px'}
                        show={true}
                        variant={ButtonStyles.secondary}
                        clearNotesBg={true}
                        margin={'0px 18px 0px 0px'}
                        clicked={() => {
                            try {
                                onCancel();
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                    >
                        <StyledDiv>{t('more.common.cancel')}</StyledDiv>
                    </Button>
                    <Button
                        id={'common-usage-adj-notes-save-button'}
                        width={'102px'}
                        mobileWidth={'150px'}
                        height={'38px'}
                        show={true}
                        variant={
                            notesText.trim().length > 0
                                ? ButtonStyles?.primary
                                : ButtonStyles?.surgeryNotesDisabled
                        }
                        disabled={notesText.trim().length === 0}
                        clicked={() => {
                            try {
                                if (notesText.trim().length > 0) {
                                    onSave();
                                }
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                    >
                        <StyledDiv>{t('more.common.save')}</StyledDiv>
                    </Button>
                </ButtonDiv>
                {!mobile && <Line></Line>}
            </DisplayDiv>
            <div style={{ marginTop: '20px' }}>
                {!hideHeader && (
                    <Subtitle margin="0 0 5px 0">{subHeader}</Subtitle>
                )}
                {showSuccessMessage ? (
                    <SubtitleDiv>
                        <SuccessMsgContainer
                            marginRight={'5px'}
                            marginBottom={'5px'}
                        />
                    </SubtitleDiv>
                ) : null}
                {mobile ? (
                    <NotesContainer margin="15px 0 0 -20px">
                        {notesDisplay.length === 0 ? (
                            <div
                                style={{
                                    fontFamily: 'AvenirNextWorld Italic',
                                    fontSize: '14px',
                                    color: '#202124',
                                    opacity: '0.7',
                                    padding: '20px',
                                }}
                            >
                                {t('reportUsage.usageAdjNote.emptyText')}
                            </div>
                        ) : (
                            notesDisplay.map((item, index) => (
                                <MainContainerItems
                                    key={index}
                                    setMarginBottom={true}
                                    setWidth="100%"
                                    mbSetWidth="107%"
                                    borderLeft={
                                        item.isNew
                                            ? '2px solid #12C8F7'
                                            : 'none'
                                    }
                                    paddingLeft="20px"
                                    marginLeft="-20px"
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <Subtitle
                                            showAstrisk={false}
                                            fontSize="13px"
                                        >
                                            <b style={{ marginRight: '10px' }}>
                                                {t('equity.surgery.createdBy')}{' '}
                                                {item.userName || ''}
                                            </b>
                                        </Subtitle>
                                        {item.isNew ? (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    gap: '10px',
                                                }}
                                            >
                                                <Edit>
                                                    <img
                                                        src={
                                                            editIndex === index
                                                                ? MDIEditDisable
                                                                : MDIedit
                                                        }
                                                        alt="Edit note"
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() =>
                                                            onEdit(item, index)
                                                        }
                                                    />
                                                </Edit>
                                                <Del>
                                                    <img
                                                        src={DeleteIcon}
                                                        alt="Delete note"
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() =>
                                                            onDelete(item, index)
                                                        }
                                                    />
                                                </Del>
                                            </div>
                                        ) : null}
                                    </div>
                                    <Subtitle>
                                        {getDisplayDate(item.creationDate)}
                                        {' | '}
                                        {convertTime24To12(
                                            new Date(item.creationDate)
                                        )}{' '}
                                    </Subtitle>
                                    {editIndex === index ? (
                                        <EditCard
                                            value={editValue ?? item.note}
                                            editTextHandler={onEditChange}
                                            CloseBlue={CloseBlue}
                                            closeEditHandler={onEditClose}
                                            TickBlue={TickBlue}
                                            blueTickHandler={() =>
                                                onEditSave(index)
                                            }
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                color: '#202124',
                                                fontFamily:
                                                    'AvenirNextWorld Regular',
                                                wordBreak: 'break-word',
                                                fontSize: '15px',
                                                marginTop: '4px',
                                            }}
                                        >
                                            {item.note}
                                        </div>
                                    )}
                                </MainContainerItems>
                            ))
                        )}
                    </NotesContainer>
                ) : (
                    <NoteDiv>
                        {notesDisplay.length === 0 ? (
                            <div
                                style={{
                                    fontFamily: 'AvenirNextWorld Italic',
                                    fontSize: '14px',
                                    color: '#202124',
                                    opacity: '0.7',
                                    padding: '20px',
                                }}
                            >
                                {t('reportUsage.usageAdjNote.emptyText')}
                            </div>
                        ) : (
                            notesDisplay.map((item, index) => (
                                <React.Fragment key={index}>
                                    <Flex showBorder={item.isNew && editIndex !== index ? true : false}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                width: '100%',
                                            }}
                                        >
                                            <Creator>
                                                {t('equity.surgery.createdBy')}{' '}
                                                {item.userName || ''}
                                            </Creator>
                                            <Bar>|</Bar>
                                            <StyledDate>
                                                {getDisplayDate(
                                                    item.creationDate
                                                )}
                                            </StyledDate>
                                            <Bar>|</Bar>
                                            <Time>
                                                {convertTime24To12(
                                                    new Date(item.creationDate)
                                                )}{' '}
                                            </Time>
                                        </div>
                                        {item.isNew ? (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    gap: '10px',
                                                }}
                                            >
                                                <Edit>
                                                    <img
                                                        src={
                                                            editIndex === index
                                                                ? MDIEditDisable
                                                                : MDIedit
                                                        }
                                                        alt="Edit note"
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() =>
                                                            onEdit(item, index)
                                                        }
                                                    />
                                                </Edit>
                                                <Del>
                                                    <img
                                                        src={DeleteIcon}
                                                        alt="Delete note"
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() =>
                                                            onDelete(item, index)
                                                        }
                                                    />
                                                </Del>
                                            </div>
                                        ) : null}
                                    </Flex>
                                    {editIndex === index ? (
                                        <div
                                            style={{
                                                borderLeft: '2px solid #12c8f7',
                                            }}
                                        >
                                            <EditCard
                                                value={editValue ?? item.note}
                                                editTextHandler={onEditChange}
                                                CloseBlue={CloseBlue}
                                                closeEditHandler={onEditClose}
                                                TickBlue={TickBlue}
                                                blueTickHandler={() =>
                                                    onEditSave(index)
                                                }
                                            />
                                        </div>
                                    ) : (
                                        <NoteDetails
                                            hideBorder={item.isNew ? false : true}
                                        >
                                            {item.note}
                                        </NoteDetails>
                                    )}
                                </React.Fragment>
                            ))
                        )}
                    </NoteDiv>
                )}
            </div>
        </div>
    );
};

export default UsageAdjNoteSection;
